export const propsMix={
  data(){
    return{
      props: {},
    }
  },
  methods:{
    changeProp(prop) {
      console.log('ddd',prop)
      for (let key in prop) {
        this.props[key] = prop[key]

        // if (key == 'stand') {
        //   this.setStandObject(prop[key])
        // }
        if (key == 'click') {
          this.setHideElementCanvas(prop[key])
        }
        if (key == 'up') {
          this.setUpElementCanvas()
        }

        if (key == 'down') {
          this.setDownElementCanvas()
        }

        if (key == 'fontSize') {
          this.setFontSizeElementCanvas(prop[key])
        }
        if (key == 'colorText') {
          this.setColorTextElementCanvas(prop[key])
        }
        if (key == 'colorBorder') {
          this.setStrokeElementCanvas(prop[key])
        }
        if (key == 'italic') {
          this.setItalicElementCanvas(prop[key])
        }
        if (key == 'bold') {
          this.setBoldElementCanvas(prop[key])
        }
        if (key == 'underline') {
          this.setUnderlineElementCanvas(prop[key])
        }
        if (key == 'colorFill') {
          this.setFillElementCanvas(prop[key])
        }
        if (key == 'line') {
          this.setStrokeWidthElementCanvas(prop[key])
        }
      }
    },
    lockElementCanvas() {
      this.canvas.getActiveObjects().map((ele) => {
        ele.selectable = false;
      })
      this.canvas.discardActiveObject()
      this.canvas.renderAll()
    },
    visibleActiveElement() {
      this.canvas.getActiveObjects().map((element) => {
        element.visible = !element.visible

      })
      this.canvas.discardActiveObject()
      this.canvas.renderAll()
    },
    setBoldElementCanvas(bool) {
      this.canvas.getActiveObjects().map((element) => {
        element.set('fontWeight', bool ? 'bold' : 'normal')
      })
      this.canvas.requestRenderAll()
    },
    setColorTextElementCanvas(string) {
      this.canvas.getActiveObjects().map((element) => {
        element.set('fill', string)
      })
      this.canvas.requestRenderAll()
    },
    setFontSizeElementCanvas(bool) {
      this.canvas.getActiveObjects().map((element) => {
          element.set('fontSize', bool)
          element.set('scaleX', 1)
          element.set('scaleY', 1)
      })
      this.canvas.requestRenderAll()
    },
    setHideElementCanvas(item) {
      console.log('setHideElementCanvas',item);
      // if(item === 'stand'){
      //   this.canvas.getActiveObjects().map((element) => {
      //     element.set('event', {
      //       type:'stand',
      //       value:'A345'
      //     })
      //
      //   })
      // }
      if(item === 'roof'){
        this.canvas.getActiveObjects().map((element) => {
          element.set('event', {
            type:'opacity',
            value:0.8
          })
        })
      }

      if(item === 'hall'){
        this.canvas.getActiveObjects().map((element) => {
          element.set('event', {
            type:'opacity',
            value:1.2
          })
        })
      }
      if(item === 'hallTitle'){
        this.canvas.getActiveObjects().map((element) => {
          element.set('event', {
            type:'opacity',
            value:1.19
          })
        })
      }
      if(item === 'smalltitle'){
        this.canvas.getActiveObjects().map((element) => {
          element.set('event', {
            type:'opacityDown',
            value:3
          })
        })
      }
      this.canvas.requestRenderAll()
      console.log( this.canvas.getActiveObjects())
    },
    setUpElementCanvas() {
      console.log('sendToBack')
      this.canvas.getActiveObjects().map((element) => {
        this.canvas.sendToBack(element)
      })
      this.canvas.requestRenderAll()
    },
    setDownElementCanvas() {
      console.log('bringToFront')
      this.canvas.getActiveObjects().map((element) => {
        this.canvas.bringToFront(element)
      })
      this.canvas.requestRenderAll()
    },
    setUnderlineElementCanvas(bool) {
      this.canvas.getActiveObjects().map((element) => {
        element.set('underline',Boolean(bool))
      })
      this.canvas.renderAll()
    },
    setItalicElementCanvas(bool) {
      this.canvas.getActiveObjects().map((element) => {
        element.set('fontStyle', bool ? 'italic' : 'normal')
      })
      this.canvas.renderAll()
    },
    setFillElementCanvas(color) {
      this.canvas.getActiveObjects().map((ele) => {
        ele.set('fill', color)
      })
      this.canvas.renderAll()
    },
    setStrokeElementCanvas(color) {
      this.canvas.getActiveObjects().map((ele) => {
        ele.set('stroke', color)
      })
      this.canvas.renderAll()
    },
    setStrokeWidthElementCanvas(item) {
      console.log('item', item)
      this.canvas.getActiveObjects().map((ele) => {
      ele.set('strokeWidth', parseInt(item))
      })
      this.canvas.renderAll()
    },
    setUpDownElementCanvas(bool) {
      const activeObj = this.canvas.getActiveObject();
      console.log(activeObj && this.canvas.getObjects().indexOf(activeObj));
      console.log(this.canvas.getObjects().map(ele => ele.type));
      if (bool) {
        this.canvas.moveTo(activeObj, this.canvas.getObjects().indexOf(activeObj) + 1);
      } else {
        this.canvas.moveTo(activeObj, this.canvas.getObjects().indexOf(activeObj) - 1);
      }
      console.log(this.canvas.getObjects().map(ele => ele.type));
      this.canvas.renderAll()
    },
    setOpacityElementCanvas(num) {
      this.canvas.forEachObject(function (o) {
        if (o.name !== 'holst') {
          o.opacity = num
        }
      });
    },
  }
}
